const inChainId = process.env.REACT_APP_CHAINID;

export{
  inChainId
}